export default __webpack_public_path__ + "781c256ce011ccdb1abf1fd3b54e811a.png";